import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import CommissaryLayout from "../../layout/CommissaryLayout";
import { UserInfo } from "../../../context";
import CommissaryAddUnit from "./CommissaryAddUnit";
import moment from "moment";
import CommissaryUnitEdit from "./CommissaryUnitEdit";

const CommissaryUnits = () => {
  const [commissaryList, setCommissaryList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at - b.created_at,
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      sorter: (a, b) => a.unit - b.unit,
      filters: [
        {
          text: "Piece(s)",
          value: "Piece(s)",
        },
        {
          text: "Bottle(s)",
          value: "Bottle(s)",
        },
        {
          text: "Vial(s)",
          value: "Vial(s)",
        },
        {
          text: "Box(s)",
          value: "Box(s)",
        },
      ],
      onFilter: (value, record) => record.unit.includes(value),
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getCommissaryUnits = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/unit-list", { params })
      .then((response) => {
        const data = response.data;
        setCommissaryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getCommissaryUnits();
  }, [getCommissaryUnits]);

  const searchable = commissaryList.data.filter((data) => {
    return data.unit.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <CommissaryLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            placeholder="Search unit"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Add Unit
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <CommissaryAddUnit
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getCommissaryUnits={() => getCommissaryUnits()}
        />
      )}

      {editDrawer && (
        <CommissaryUnitEdit
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getCommissaryUnits={() => getCommissaryUnits()}
          selectedData={selectedData}
        />
      )}
    </CommissaryLayout>
  );
};

export default CommissaryUnits;
